import type { RequestThirdPledgerPayload, RequestThirdPledgerResponse } from 'share/types/api/3rdPledger'
import { SetApplicationDecisionPayload, SetApplicationDecisionResponse } from 'share/types/api/main'

import { api } from '.'

const authApi = api.injectEndpoints({
  endpoints: build => ({
    requestThirdPledger: build.mutation<RequestThirdPledgerResponse, RequestThirdPledgerPayload>({
      query: body => ({
        url: 'scoring/third-party-pledge-request/',
        method: 'POST',
        body
      })
    }),
    setThirdPartyPledgeDecision: build.mutation<SetApplicationDecisionResponse, SetApplicationDecisionPayload>({
      query: ({ id, ...body }) => ({
        url: `scoring/third-party-pledge-request/${id}/make-decision/`,
        method: 'POST',
        body
      })
    })
  })
})

export const { useRequestThirdPledgerMutation, useSetThirdPartyPledgeDecisionMutation } = authApi
